import { Component, OnDestroy, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DxMenuComponent } from 'devextreme-angular/ui/menu';
import { Subscription } from 'rxjs';
import { ConfigService } from 'src/app/share/services/config.service';
import { LanguageService } from 'src/app/share/services/language.service';
import { UrlService } from 'src/app/share/services/url.service';

@Component({
  selector: 'app-citizen-header-extern',
  templateUrl: 'citizen-header-extern.component.html',
  styleUrls: ['citizen-header-extern.component.scss'],
  standalone: false,
})
export class CitizenHeaderExternComponent implements OnDestroy {
  @ViewChild('menu', { static: false }) menu: DxMenuComponent;

  window = window;
  PortalTitel: string;
  changeLanguage: boolean;

  menuitemsLeft: any[] = [
    {
      id: 1,
      key: 'startPage',
      icon: 'home',
      selectable: true,
      path: '/extern/start',
    },
    {
      id: 2,
      key: 'searchInstitution',
      icon: 'find',
      selectable: true,
      path: '/extern/search',
    },
    {
      id: 4, // Dummy (benötigt)
      visible: false,
      isHiddenDummy: true,
    },
  ];

  menuitemsRight: any[] = [
    // {
    //   id: 1,
    //   key: 'inquireChild',
    //   icon: 'tableproperties',
    //   selectable: true,
    //   path: '/extern/select',

    //   disabled: false,
    //   ident: 'AntragStellen'
    // },
    {
      id: 1,
      key: 'selectedInstitutions',
      icon: 'selectall',
      selectable: true,
      path: '/extern/select',

      disabled: false,
      ident: 'AntragStellen',
    },
    {
      id: 2, // Dummy (benötigt)
      visible: false,
      isHiddenDummy: true,
    },
  ];

  menuitemsHandyModus: any[] = [
    {
      text: '',
      icon: 'menu',
      items: this.menuitemsLeft.concat(this.menuitemsRight),
    },
  ];

  userMenuItems: any[] = [
    {
      id: 1,
      text: '',
      icon: 'user',
      selectable: true,
      path: '/extern/login',
    },
    {
      id: 2, // Dummy (benötigt)
      visible: false,
      isHiddenDummy: true,
    },
  ];

  selectedItemLeft: any;
  selectedItemRight: any;

  languages: any[] = [
    {
      text: 'selectLanguage',
      image: 'assets/german.png',

      items: [
        {
          key: 'de',
          image: 'assets/german.png',
          text: 'flagGerman',

          onClick: () => {
            this.onLangClick('de');
          },
        },
        {
          key: 'en',
          image: 'assets/english.png',
          text: 'flagEnglish',

          onClick: () => {
            this.onLangClick('en');
          },
        },
      ],
    },
  ];

  get selectedItemsLeft() {
    return [this.selectedItemLeft];
  }

  get selectedItemsRight() {
    return [this.selectedItemRight];
  }

  selectedIds: number[] = [];
  subscription_get_externSelectedIdsQueryParams: Subscription;

  selectedLanguageObservable: Subscription;

  constructor(private router: Router, private languageService: LanguageService, private urlService: UrlService, public configService: ConfigService) {
    this.initMenu();

    let allowedLanguagesFromDb = this.configService.getGlobalSetting('allowedLanguages').split(',');
    if (
      allowedLanguagesFromDb === undefined ||
      allowedLanguagesFromDb === null ||
      allowedLanguagesFromDb[0] === ' ' ||
      allowedLanguagesFromDb[0] === ''
    ) {
      this.changeLanguage = false;
    } else {
      this.changeLanguage = true;
    }

    this.selectedLanguageObservable = languageService.get_selectedLanguageObservable.subscribe((lang) => {
      this.PortalTitel =
        lang === 'de'
          ? this.configService.getGlobalSetting('portalTitelDE')
          : lang === 'en'
          ? this.configService.getGlobalSetting('portalTitelEN')
          : this.configService.getGlobalSetting('portalTitelDE');

      var newLangItem = this.languages[0].items.find((x) => x.key === lang);
      this.languages[0].image = newLangItem.image;

      this.menuitemsLeft.forEach((x) => {
        if (x.key !== null && x.key !== undefined && x.key.length > 0) {
          x.text = languageService.translate(x.key);
        }
      });

      this.menuitemsRight.forEach((x) => {
        if (x.key !== null && x.key !== undefined && x.key.length > 0) {
          x.text = languageService.translate(x.key);
        }
      });
    });

    this.setSelectedInstitutionNumber();
  }

  ngOnDestroy(): void {
    if (this.selectedLanguageObservable) {
      this.selectedLanguageObservable.unsubscribe();
    }

    if (this.subscription_get_externSelectedIdsQueryParams) {
      this.subscription_get_externSelectedIdsQueryParams.unsubscribe();
    }
  }

  initMenu() {
    if (this.configService.getGlobalSetting('brRechnerOn') === '1') {
      const new_item = {
        id: 3,
        key: 'calculator',
        icon: 'formula',
        selectable: true,
        path: '/extern/calculator',
      };

      this.menuitemsLeft.push(new_item);
      this.menuitemsHandyModus[0].items.push(new_item);
    }

    this.selectedItemLeft = this.menuitemsLeft.find((x) => this.router.url === x.path);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentRoute = this.menuitemsLeft.find((x) => event.url.startsWith(x.path));
        if (currentRoute !== null && currentRoute !== undefined) {
          this.selectedItemLeft = currentRoute;
        } else {
          this.selectedItemLeft = this.menuitemsLeft.find((x) => x.isHiddenDummy);
        }
      }
    });

    this.selectedItemRight = this.menuitemsRight.find((x) => this.router.url === x.path);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentRoute = this.menuitemsRight.find((x) => event.url.startsWith(x.path));
        if (currentRoute !== null && currentRoute !== undefined) {
          this.selectedItemRight = currentRoute;
        } else {
          this.selectedItemRight = this.menuitemsRight.find((x) => x.isHiddenDummy);
        }
      }
    });
  }

  onMenuItemClick(e) {
    if (e.itemData !== null && e.itemData !== undefined && e.itemData.path !== null && e.itemData.path !== undefined && e.itemData.path.length > 0) {
      this.selectedItemLeft = e.itemData;
      this.urlService.naviToPreserveQueryParams(e.itemData.path);
      // console.debug('e.data: ', e.itemData.path);
    }
  }

  onLogoClick() {
    this.urlService.naviToPreserveQueryParams('extern/start');
  }

  onClickLogin() {
    this.selectedItemLeft = this.menuitemsLeft[2];
    this.urlService.naviToPreserveQueryParams('extern/login');
  }

  onClickSelect() {
    this.urlService.naviToPreserveQueryParams('extern/select');
  }

  onLangClick(lang) {
    this.languageService.setLanguage(lang);
    this.setSelectedInstitutionNumber();
  }

  private setSelectedInstitutionNumber() {
    this.subscription_get_externSelectedIdsQueryParams = this.urlService.get_externSelectedIdsQueryParams.subscribe((ids) => {
      this.selectedIds = ids;
      const exist = this.menuitemsRight.find((x) => x.ident === 'AntragStellen');
      if (exist !== null && exist !== undefined) {
        if (this.selectedIds !== null && this.selectedIds !== undefined && this.selectedIds.length > 0) {
          exist.disabled = false;
          this.menuitemsRight.find((x) => x.id === 1).text =
            this.languageService.translate('selectedInstitutions') + ' (' + this.selectedIds.length + ')';
        } else {
          exist.disabled = true;
          this.menuitemsRight.find((x) => x.id === 1).text = this.languageService.translate('selectedInstitutions');
        }
      }
    });
  }
}
